import { baseApi } from '@/lib/utils'

export interface SavedFilter {
  id: number
  name: string
  page: string
  filters: Record<string, unknown>
  created_at: string
  updated_at: string
}

export interface SavedFiltersResponse {
  success: boolean
  data: SavedFilter[]
}

export interface CreateSavedFilterRequest {
  name: string
  page: string
  filters: Record<string, unknown>
}

export const savedFiltersApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getSavedFilters: builder.query<SavedFiltersResponse, string>({
      query: page => ({
        url: '/saved-filters',
        params: { page },
      }),
      providesTags: ['SavedFilters'],
    }),
    createSavedFilter: builder.mutation<
      { success: boolean; data: SavedFilter },
      CreateSavedFilterRequest
    >({
      query: data => ({
        url: '/saved-filters',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['SavedFilters'],
    }),
    deleteSavedFilter: builder.mutation<{ success: boolean }, number>({
      query: id => ({
        url: `/saved-filters/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['SavedFilters'],
    }),
    updateSavedFilter: builder.mutation<
      { success: boolean },
      { id: number; name?: string; filters?: Record<string, unknown> }
    >({
      query: ({ id, ...body }) => ({
        url: `/saved-filters/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['SavedFilters'],
    }),
  }),
})

export const {
  useGetSavedFiltersQuery,
  useCreateSavedFilterMutation,
  useDeleteSavedFilterMutation,
  useUpdateSavedFilterMutation,
} = savedFiltersApi
